import { useEffect, useState } from 'react';
import { useQueryClient } from 'react-query';
import {
  IPageProps,
  IWidgetType,
  retrieveAppSession,
  usePage,
  useTranslate,
} from '@vfit/consumer/data-access';
import { Footer, Header } from '@vfit/shared/components';
import { SoftManagerService } from '@vfit/consumer/providers';
import { AppMobile, useFooter, useHeader, useTrackingProvider } from '@vfit/shared/data-access';
import { RedHubCard, StickyBannerHeader } from '@vfit/consumer/components';
import Widgets from '../../Widgets/widgets';
import { withProtected } from '../Hoc/withProtected';
import TaggingBlank from './blank.tagging';
import BrightSky from '../../BrightSky/brightSky';
import { getProductsShowedInHub } from './blank.utils';
import { useEnergyFlow } from '@vfit/consumer/hooks';
import { colors } from '@vfit/shared/themes';
import EnergyContainer from '../EnergyContainer/energyContainer';
import { NewLoader } from './blank.style';
import { Loader } from './components/Loader/loader';
import { WidgetSpacer } from '../../Widgets/widgets.style';

const BlankContainer = ({ page }: IPageProps) => {
  const { pageNavigation, customHubs } = usePage();
  const client = useQueryClient();
  const { translate } = useTranslate();
  const { elements, haveHeader, isHeaderSmall, haveFooter, isDisabledInitialTrack, isNewHeader } =
    page?.params || {};
  const { isReady: isReadyTagging } = useTrackingProvider();
  const { widgets, taggingOptions, stickybanner, topheaderbanner, redhubcard } = elements || {};
  const { header, tagging } = useHeader(pageNavigation);
  const { footer } = useFooter(pageNavigation);
  // const [r, setR] = useState('');
  const firstWidgetType = page?.params?.elements?.widgets?.sliders?.[0]?.type;
  const haveHub =
    firstWidgetType === IWidgetType.HUB ||
    firstWidgetType === IWidgetType.HUB_LITE ||
    firstWidgetType === IWidgetType.HUB_CUSTOM ||
    firstWidgetType === IWidgetType.HUB_CUSTOM_LITE;

  client.setQueryData('pageDatalayer', {
    event: [taggingOptions?.event || 'view'],
    event_label: taggingOptions?.eventLabel || '',
    opts: taggingOptions,
    pageProduct: getProductsShowedInHub(widgets?.sliders || [], customHubs),
    cartProduct: undefined,
    visitorTrackingOpts: SoftManagerService(client).getUser(),
  });

  useEffect(() => {
    if (AppMobile.checkIsApp()) {
      retrieveAppSession();
    }
  }, []);

  return (
    <div>
      {isReadyTagging && (
        <TaggingBlank
          widgets={widgets?.sliders || []}
          customHubs={customHubs}
          taggingOptions={taggingOptions}
          isDisabledInitialTrack={isDisabledInitialTrack}
        />
      )}
      {haveHeader && header && !AppMobile.checkIsApp() && (
        <Header
          onTrack={tagging}
          header={header}
          lite={isHeaderSmall}
          disablePaddingTop={isHeaderSmall && !haveHub}
          onTranslate={translate}
          isExtendedHeader={isNewHeader}
          topHeaderBanner={topheaderbanner}
        />
      )}
      {stickybanner && <StickyBannerHeader bannerCustomConfig={stickybanner} />}
      {widgets?.sliders && (
        <WidgetSpacer
          isOverlap={
            (isHeaderSmall && !(widgets?.sliders?.[0]?.type === IWidgetType?.TOP_HERO)) || false
          }
          className="noPadding"
        >
          <Widgets widgets={widgets?.sliders} tagging={tagging} />
        </WidgetSpacer>
      )}
      {redhubcard && <RedHubCard redHubCardConfig={redhubcard} />}
      {haveFooter && footer && !AppMobile.checkIsApp() && (
        <Footer onTrack={`${tagging}_FOOTER`} footer={footer} subChildren={<BrightSky />} />
      )}
    </div>
  );
};

const Blank = (props: IPageProps) => {
  const { page } = props || {};
  const isEnergyPage = page?.params?.isEnergy || false;
  const { isLoading: isLoadingEnergyFlow, isEligible: isEligibleEnergyFlow } =
    useEnergyFlow(isEnergyPage);

  // region ENERGY
  /*
  This is automatically added if page contains in path the key word ENERGY
  for https://privati.vodafone.it/energy example
  this is a blank page and goes here
  */
  if (isLoadingEnergyFlow)
    return (
      <NewLoader>
        <Loader color={colors.$e60000} />
      </NewLoader>
    );

  if (isEnergyPage && !isEligibleEnergyFlow) return null;
  // endregion

  return (
    <>
      <BlankContainer {...props} />
      {isEnergyPage && <EnergyContainer />}
    </>
  );
};

const BlankProtected = withProtected()(Blank);

export default BlankProtected;

